module.exports = __webpack_public_path__ + "img/conserver.38925f3d.png";